import React from 'react';
import {Switch} from 'react-router-dom';
import { settingsFormTypes, formModes } from '../constants';
import { documentsRoutes } from '../AppRoutes';
import { Content } from './Content';
import { ListOfSearchResults } from './listsOfAlfresco/ListOfSearchResults';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import { StatutoryDocumentsPage } from './pages/StatutoryDocumentsPage';
import { TemplateDocumentsPage } from './pages/TemplateDocumentsPage';
import { PricesTable } from './PricesTable';
import { PrivateRoute } from './PrivateRoute';
import { Settings } from './Settings';
import { Document } from './documents/Document';
export function Home() {
    return (
        <Content>
            <Switch>
                <PrivateRoute exact path='/prices' component={PricesTable} />
                <PrivateRoute path='/statutoryDocs/:tab?' component={StatutoryDocumentsPage} />
                <PrivateRoute path='/templates/:tab?' component={TemplateDocumentsPage} />
                <PrivateRoute exact path='/settings/:tab?' component={Settings} controller={settingsFormTypes.settingsType} />
                <PrivateRoute exact path='/search' component={ListOfSearchResults} key={window.location.search} />
                <PrivateRoute path='/admin/:tab?' component={Settings} controller={settingsFormTypes.adminType} />
                <PrivateRoute exact path='/no-acces' component={AccessDeniedPage} />
                {documentsRoutes.map((item) =>
                    item.modes.map((mode) =>
                        <PrivateRoute key={`/${item.baseUrl}/${mode}`} path={`/${mode === formModes.create ? item.baseUrl : "document"}/${mode === formModes.create ? "" : mode}${(mode === formModes.create ? "" : "/:id")}`} component={Document} />
                    )
                )}
            </Switch>
        </Content>
    );
}
